
<template>
  <div class="shops">
    <div class="contents">
      <div>
        <div class="fx">
          <div class="fx searchNo">
            <div class="searchtitle">售货车</div>
            <el-select
              v-model="carNames"
              @change="carchosed"
              placeholder="请选择"
            >
              <el-option
                v-for="item in productcarList"
                :key="item.value"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-button
              style="margin-left: 15px"
              type="primary"
              icon="el-icon-search"
              @click="searchorder"
              >搜索</el-button
            >
            <el-button class="" type="success" @click="handlerAdd"
              >新增</el-button
            >
            <el-button class="" type="success" @click="empty"
              >清空</el-button
            >
          </div>
        </div>
      </div>

      <!-- 表格封装 -->
      <my-eltable
        class="myTables"
        ref="mt"
        id="printTable"
        :tableData="tableData"
        :tabheight="tabheight"
        :tableHeader="tableHeader"
        :operateList="operateList"
        :loading="loading"
        :isshow="isshow"
        :total="total"
        @handlerTable="handlerModify"
        @handlerDelete="delClick"
      ></my-eltable>
      <!-- 分页 -->
      <div class="fy">
        <el-pagination
          class="fx fend"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="100"
          layout="sizes, prev, pager, next"
          :total="total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog :visible.sync="isAdd">
      <el-form :model="shopInfo" ref="shopInfo" label-width="100px">
        <el-form-item label="头像" prop="name">
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :show-file-list="false"
            :headers="headers"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="用户名" prop="name">
          <el-input
            v-model="shopInfo.username"
            placeholder="请输入用户名"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="name">
          <el-input
            type="password"
            v-model="shopInfo.password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="name">
          <el-input
            type="password"
            v-model="shopInfo.confirmPassword"
            placeholder="请再次输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="昵称" prop="name">
          <el-input
            v-model="shopInfo.nickname"
            placeholder="请输入昵称"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="name">
          <el-input
            v-model="phone"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="售卖亭" prop="name" v-if="isMain == 0 || isMain == 2">
          <el-select v-model="carName" @change="carchose" placeholder="请选择">
            <el-option
              v-for="item in productcarList"
              :key="item.value"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="用户类型" prop="name" v-if="isMain == 1">
          <el-select v-model="customerName" @change="customerchose" placeholder="请选择">
            <el-option
              v-for="item in customertypeList"
              :key="item.value"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
                <el-form-item v-if="isMain == 1" label="售货店">
          <el-checkbox-group v-model="checkedShops" :max="isChecks" @change="choseShops">
            <el-checkbox
              v-for="(item, index) in shops"
              :value="item.name"
              :label="item.id"
              :key="index"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="状态" prop="name">
          <el-radio v-model="shopInfo.status" label="1">启用</el-radio>
          <el-radio v-model="shopInfo.status" label="0">禁用</el-radio>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="isModify"
            type="primary"
            @click="modifyForm('shopInfo')"
            >确认修改</el-button
          >
          <el-button v-else type="primary" @click="submitForm('shopInfo')"
            >立即创建</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  cashierList,
  addCashier,
  editCashier,
  delCashier,
  modifyCashier,
} from "@/http/cashier.js";
import { productcar } from "@/http/order.js";
import { UPLOAD_API, FILE_URL } from '@/config'

// 组件中引用
import MyEltable from "../../components/el_table";
import elMesBox from "../../components/el_message_box/Index";

export default {
  components: { MyEltable, elMesBox },
  created() {
    this.listPages();
    this.getproductcar();
    console.log(this.routes);
    this.isMain = localStorage.getItem("isMain");
    console.log(this.isMain, "aaaaaaaa");
  },
  mounted() {
    this.getproductcar()
  },
  computed: {
    routes() {
      return this.$router.options.routes[1].children;
    },
  },
  data() {
    return {
      uploadUrl: UPLOAD_API, // 上传地址
      isChecks: null,
      shops: [],
      checkedShops: [],
      customerName: '',
      customertypeList: [
        {name: '管理员',value: '2',id: 2},
        {name: '收银员',value: '0',id: 0}
      ],
      isMain: '',
      productcarList: [],
      carName: "",
      carNames: "",
      isAdd: false, //新增弹窗控制
      isModify: false, //修改弹窗控制
      imageUrl: "",
      shopInfo: { status: "1" },
      timePeriod: [],
      name: "",
      content: "",
      contdate: "",
      value1: "",
      input: "",
      loading: false,
      isshow: true,
      tabheight: "100%",
      tableHeader: [
        // 表头
        { prop: "userId", label: "用户ID" },
        { prop: "username", label: "账号" },
        { prop: "nickname", label: "昵称" },
        { prop: "kioskName", label: "售卖亭" },
        { prop: "statusName", label: "状态" },
        { prop: "isMains", label: "用户状态" },
      ],
      tableData: [],
      operateList: [
        { name: "修改", type: "primary", size: "mini", mark: 1 },
        { name: "删除", type: "danger", size: "mini", mark: 2 },
      ],
      newdata: {
        name: "",
        content: "",
        contdate: "",
      },
      currentPage: 1,
      pagesize: 10,
      total: 0,
      headers:{},
      phone:'',
      kioskId: null
    };
  },
  watch: {
      isAdd: {
      handler(newValue,oldValue) {
        //newValue 改变后的数据
        //oldValue  改变前的数据
        console.log(newValue,oldValue)
        if(!newValue){
          this.shopInfo.kioskId = null
        }
      }
      //,deep: true
    }
  },
  methods: {
    choseShops(e){
      this.shopInfo.kioskIdList = this.checkedShops
      console.log(e)
    },
    //清空按钮
    empty(){
      this.kioskId = null
      this.carNames = ''
    },
    //搜索
    searchorder() {
      console.log(this.shopInfo);
      this.listPages();
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file);
      this.imageUrl = URL.createObjectURL(file.raw);
      this.shopInfo.avatar = res.msg[0];
      console.log(this.shopInfo.avatar);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    //售货车数量
    async getproductcar(shoplist) {
      let res = await productcar({
        limit: null,
      });
      let shops = res.data;
      if(shoplist){
        shoplist.forEach(item => {
        shops.forEach((itam,index) => {
          if(item.id == itam.id){
            shops.splice(index,1,item)
          }
        })
      })
      }
      
      this.shops = shops
      console.log(this.shops);
      this.productcarList = res.data;
    },
    carchose(e) {
      console.log(e);
      this.shopInfo.kioskId = e;
    },
    customerchose(e,shoplist){
      console.log(this.isAdd, 'aaaaaaaa')
      if(this.isAdd){
        this.getproductcar(shoplist)
      } 
      if(!this.isModify){
        console.log(this.isModify, 'sssss')
      this.checkedShops = []
      }
      this.shopInfo.isMain = e
      // this.listshop(e)
      // this.shops = []
      if(e == 0){
        this.isChecks = 1
      }else if(e == 2){
        let len = this.shops.length
        console.log(len)
        this.isChecks = len
      }
      console.log('eeee',e);
    },
        carchosed(e) {
      console.log(e);
      this.kioskId = e;
    },
    // 点击新增
    handlerAdd() {
      this.isAdd = true;
      this.isModify = false;
      this.checkedShops = []
      this.customerName = ''
      this.isChecks = null
      this.shopInfo = { status: "1" }
      this.imageUrl = ''
      this.phone = ''
      this.carName = "";
      let token = localStorage.getItem("token");
      this.headers = {
        token,
      };
    },

    // 新增售货亭
    submitForm() {
      console.log("this.shopInfo", this.shopInfo);
      //   this.shopInfo.nhch = Number(this.shopInfo.nhch);
      this.shopInfo.phone = this.phone;
      addCashier(this.shopInfo).then((res) => {
        console.log(res);
        if (res.code === 1) {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success",
          });
          this.shopInfo = { status: "1" };
          this.imageUrl = "";
          this.carName = "";
          this.isAdd = false;
          this.listPages();
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 点击修改
    async handlerModify(val) {
      this.isAdd = true;
      this.isModify = true;
      this.checkedShops.splice(0)
      let token = localStorage.getItem("token");
      this.headers = {
        token,
      };
      this.carName = "";
      console.log("val", val);
      this.shopInfo = val;
      this.phone = val.mobile;
      this.carName = val.kioskId;
      console.log(val.isMain)
      let shoplist = val.kioskList
      shoplist.forEach(item => {
        item.checked = true
        this.checkedShops.push(item.id)
        // this.shopInfo.kioskIdList.push(item.id)
      })
      console.log(this.checkedShops)
      this.customerchose(val.isMain,shoplist)
      this.shopInfo.kioskIdList = this.checkedShops
      this.customerName = val.isMains
      this.imageUrl = `${FILE_URL}/${val.avatar}`
      val.status = String(val.status);
    },
    // 修改收银员信息
    async modifyForm() {
      this.shopInfo.phone = this.phone;
      let res = await editCashier(this.shopInfo);
      console.log("res", res);
      if (res.code === 1) {
        this.$message({
          showClose: true,
          message: "修改成功",
          type: "success",
        });
        this.isAdd = false;
        this.isModify = false;
          this.shopInfo.kioskId = null
        this.listPages();
      } else {
        this.$message({
          showClose: true,
          message: res.msg,
          type: "error",
        });
      }
    },
    // 获取收银员列表
    async listPages() {
      console.log(localStorage.getItem("token"));
      let query = {
        page: this.currentPage + "",
        limit: this.pagesize + "",
        kioskId: this.kioskId,
      };
      let res = await cashierList(query);
      console.log("res", res);
      let list = res.data.list;
      list.forEach((item) => {
        if (item.status == 0) {
          item.statusName = "已禁用";
        } else if (item.status == 1) {
          item.statusName = "已启用";
        }
      });
      list.forEach((item) => {
        if (item.isMain == 0) {
          item.isMains = "收银员";
        } else if (item.isMain == 1) {
          item.isMains = "超级管理员";
        } else if (item.isMain == 2) {
          item.isMains = "管理员";
        }
      });
      this.tableData = list;
      console.log(this.tableData)
      this.total = res.data.totalCount;
    },

    //页码改变
    currentChange(val) {
      this.currentPage = val;
      this.listPages();
    },
    //handleSizeChange
    handleSizeChange(val) {
      this.pagesize = val;
      this.listPages();
    },

    //删除数据
    async delClick(val) {
      let query = {
        userId: val.userId,
      };
      console.log("query", query);
      let res = await delCashier(query);
      console.log("res", res);
      if (res.code === 1) {
        this.$message({
          showClose: true,
          message: "删除成功",
          type: "success",
        });
        this.listPages();
      } else {
        this.$message({
          showClose: true,
          message: res.msg,
          type: "error",
        });
      }
    },
  },
};
</script>
<style lang='scss'>
// @import "../../common/css/qj_demo/index.css";

.shops {
  height: 100%;
  width: 100%;
  background: #f0f2f5;
  .contents {
    width: 98%;
    // height: 900px;
    height: calc(100% - 37px);
    background: #ffffff;
    margin: 16px auto 0;
    padding: 10px;
  }
}

.searchNo {
  flex: 1;
  align-items: center;
  color: #909399;

  input {
    width: 280px;
  }
}

.searchtitle {
  width: 80px;
}

.myTables {
  width: 100%;
  margin-top: 15px;
  // margin-left: 40px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.fy {
  width: 96%;
  margin: 10px auto 0;
}
.fend {
  justify-content: flex-end;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #18b3a3;
  color: #fff;
}
.el-pagination.is-background .el-pager li.active {
  color: #fff;
  cursor: default;
}
.el-pagination.is-background .el-pager li:hover {
  color: #18b3a3;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #18b3a3;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  background-color: #18b3a3;
  color: #fff;
}
</style>